import { Component, OnInit, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { formatNumber } from '@angular/common';
import { HttpWeedfreeService } from 'src/app/services/http-weedfree.service';

@Component({
  selector: 'app-client-document-upload',
  templateUrl: './client-document-upload.component.html',
  styleUrls: ['./client-document-upload.component.scss']
})
export class ClientDocumentUploadComponent implements OnInit {

  public client: number = 0;
  private file: File = null;

  // currently we don't bother to show any progress or messages, but
  // these are the vars needed in the html to do so
  public uploadProgress: number = 0;
  public successMessage: string = null;

  @Output() fileUploaded: EventEmitter<string> = new EventEmitter();

  get filename() {
    if (this.file == null)
      return 'Choose a file';

    return this.file.name;
  }

  get fileChosen() {
    return this.file != null;
  }

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private http: HttpWeedfreeService
  ) { }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.client = params['client'];
    });
  }

  onFileSelected(event: any) {

    if (event.target.files.length == 0) {
      this.file = null;
    } else {
      this.file = event.target.files[0];
    }
  }

  onSubmit(f: NgForm) {
    this.http.uploadClientDocument(this.client, this.file).subscribe((response) => {

      if (response.status == 'progress') {
        this.uploadProgress = Number(response.message);
        console.log(this.uploadProgress);
      } else if (response.status == 'complete') {
        this.successMessage = 'Document uploaded';
        this.uploadProgress = 0;
        this.fileUploaded.next(this.file.name);
      }

    }, (error) => {
        console.log(error);
    })
  }

}
